import { Button, Card, Container } from "@mui/material";
import { Form } from "formik";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import {RoutingList} from "../../../../constants";
import LoginHeading from "../common/LoginHeading";
import LoginInput from "../common/LoginInput";
import LoginMedantaLogo from "../common/LoginLogo";
import styles from "../Login.module.scss";

const ForgotPasswordForm: FC = (): JSX.Element => {
    const navigate = useNavigate();

    const navigateToLogin = () => {
        navigate(RoutingList.login.index.path)
    }

    return (
        <Form>
            <Container>
                <div className={`${styles.loginWrap} ${styles.formSpace}`}>
                    <>
                        <LoginMedantaLogo />

                        <Card className={styles.loginCard} variant="outlined">
                            <div className={styles.cardBody}>
                                <LoginHeading title="Forget Password ?" subtitle="Enter your email to reset your password" />
                                <LoginInput label="Email" name="email" type="email" placeholder="Email" />

                                <div
                                    className={`d-flex justify-content-center ${styles.loginFooter}`}
                                >
                                    <Button variant={"contained"} color={"error"} type="submit" className="mg-r-12">
                                        Submit
                                    </Button>
                                    <Button
                                        variant={"outlined"}
                                        color={"error"}
                                        type="button"
                                        onClick={navigateToLogin}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </Card>
                    </>
                </div>
            </Container>
        </Form>
    )
}

export default ForgotPasswordForm;